import request from '@/utils/request'

// 查询课程管理列表
export function listCourses(query) {
  return request({
    url: '/OmdCourses/courses/list',
    method: 'get',
    params: query
  })
}

// 查询课程管理详细
export function getCourses(id) {
  return request({
    url: '/OmdCourses/courses/' + id,
    method: 'get'
  })
}
export function getCoursess(name) {
  return request({
    url: '/OmdCourses/courses/courId/' + name,
    method: 'get'
  })
}
// 新增课程管理
export function addCourses(data) {
  return request({
    url: '/OmdCourses/courses',
    method: 'post',
    data: data
  })
}

// 修改课程管理
export function updateCourses(data) {
  return request({
    url: '/OmdCourses/courses',
    method: 'put',
    data: data
  })
}

// 删除课程管理
export function delCourses(id) {
  return request({
    url: '/OmdCourses/courses/' + id,
    method: 'delete'
  })
}
